import React, { useEffect, useState, createRef } from "react";
import { Button } from "../../../common/commonIndex";
import { CropImage, ImageCropper, UploadDocument } from "../../../components/componentIndex";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import imageCompression from "browser-image-compression";
import DocumentService from '../../../services/API/documentService';
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import { DocumentType } from "helper/enum";
const MAX_FILE_SIZE = 384495; // Maximum size in bytes (~375 KB)

const DocumentUpload = ({ handleNextEvent, formData, step, documentUploadList, questionData }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImagePath, setSelectedImagePath] = useState(null);
     const { state: data } = useAuthenticationContext();
     

    useEffect(() => {
        if (formData?.answer) {
            setSelectedImage(formData?.answer);
        }
    });

    /* Submit */
    const handleSubmit = (e) => {
        // e.preventDefault();
        // skip then 2 otherwise 1
        let skip = 1;
        // if (questionData?.skippedNestedQuestionID) {
        //     skip = 2;
        // }
        getFilePath(selectedImagePath);
        
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    };

    const getFilePath = async (file) => {
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
              // If file is too large, compress it
              const options = {
                maxSizeMB: 0.3, // Approximate target size
                maxWidthOrHeight: 800, // Resize if needed
                useWebWorker: true,
              };
      
              try {
                const compressedFile = await imageCompression(file, options);
                submitDocument(compressedFile);
                // return compressedFile;
                // setImage(compressedFile);
                // setImageUrl(URL.createObjectURL(compressedFile));
                console.log("Uploaded resized image:", compressedFile);
              } catch (error) {
                console.error("Error compressing image:", error);
              }
            } else {
              // If file is within size limits, use it as is
              submitDocument(file);
            //   return file;
            //   setImage(file);
            //   setImageUrl(URL.createObjectURL(file));
              console.log("Uploaded original image:", file);
            }
          }
    }
    

    const submitDocument = async selectedImagePath => {
        try {
            if (!selectedImagePath) {
                return;
            }
            // selectedImagePath = await getFilePath(selectedImagePath);
            const formDataRequest = new FormData();
            if (questionData?.question?.toLowerCase()?.includes('front of your insurance')) {
                const fileToUpload = new File([selectedImagePath], "cropped_image.jpg", { type: "image/jpeg" });
                formDataRequest.append('FileToUpload', fileToUpload);
                formDataRequest.append('DocumentType', DocumentType?.userInsuranceFrontImage);
            }
            if (questionData?.question?.toLowerCase()?.includes('back of your insurance')) {
                const fileToUpload = new File([selectedImagePath], "cropped_image.jpg", { type: "image/jpeg" });
                formDataRequest.append('FileToUpload', fileToUpload);
                formDataRequest.append('DocumentType', DocumentType?.userInsuranceBackImage);
            }
            if (questionData?.question?.toLowerCase()?.includes(`valid driver's license or photo id`)) {
                const fileToUpload = new File([selectedImagePath], "cropped_image.jpg", { type: "image/jpeg" });
                formDataRequest.append('FileToUpload', fileToUpload);
                formDataRequest.append('DocumentType', DocumentType?.userPhotoIdImage);
                // formDataRequest.append('DocumentType', DocumentType?.patientProfileImage);
            }

            const accessToken = data?.userData?.result?.token;
            const response = await DocumentService.uploadDocs(formDataRequest, accessToken, true);
            if (response?.statusCode === 200) {
                console.log('Insurance', response);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        }
    };

    const getLocalStorageData = () =>{
        const findlocalStorageData =  JSON.parse(localStorage.getItem('listOfAnswer'));
         return findlocalStorageData;
     }
     const setLocalStorageData = (data) =>{
       if(data?.length > 0){
         localStorage.setItem('listOfAnswer', JSON.stringify(data));
       }
     }

    const handleUploadFileChange = (event) => {
        let file = event;
        setSelectedImage(file);
        if (formData) {
            formData['answer'] = file;
            formData['fkAnswerIds'] = file;
        }
    };



    return (
        <div>
            {questionData && (
                <h3 className="title">{questionData?.question}</h3>
            )}
            <div className="document-uploads mt-3">
                <UploadDocument handleUploadFileChange={handleUploadFileChange} documentUploadList={questionData} formData={formData} setValue={setSelectedImage} isquestionnaire={true} setSelectedImagePath={setSelectedImagePath} />

            </div>

            {/* <div className="questionnaire-fix-btn">
                <Button
                    btnClass={'btn-primary'}
                    btnType={'button'}
                    btnName={'Continue'}
                    onClick={handleSubmit}
                    isDisabled={true}
                />
            </div> */}
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider "></div>
                <div className="footer-content">
                    <div className="skip-eligibility">
                    </div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={true}
                    />
                </div>
            </div>
        </div>
    )
};

export default DocumentUpload;

